<script>
    import { onMount } from "svelte";
    import Tooltip from "./Tooltip.svelte";
export let qrCodeBase64;
export let pixCode;

export let tooltipmsg = "Código PIX copiado!";
export let timeRemaining=0;
export let msgAguardandoPagamento;
export let collectorName;
export let transaction_amount;
export let Banco;
export let horaExpiracao;

let tooltipVisible = false;

 let interval;
  onMount(() => {
    startCountdown() ;
  });
function startCountdown() {
    interval = setInterval(() => {
      if (timeRemaining > 0) {
        timeRemaining -= 1;
      } else {
        //clearInterval(interval);
      }
    }, 1000);
  }

 const copyToClipboard = () => {
    navigator.clipboard.writeText(pixCode).then(() => {
      // Exibe o tooltip
      tooltipVisible = true;
      setTimeout(() => {
        tooltipVisible = false;
      }, 3000); // Tooltip visível por 3 segundos
    });

  };
 function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const formattedHours =
      hours > 0 ? String(hours).padStart(2, "0") + ":" : "";
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(secs).padStart(2, "0");

    return formattedHours + formattedMinutes + ":" + formattedSeconds;
  }

</script>

<div style="font-size: 24px;">
    <i class="fa fa-spinner fa-spin hourglass-icon"></i>

    <p style="font-size: 14px;">{msgAguardandoPagamento}</p>
    <hr />

    <div class="explicacoes">
        <p>
            Próximo passo: Abra o app do seu banco e escolha a opção PIX como se
            fosse fazer uma transferência, em seguida escolha a opção PIX copia
            e cola ou leia o QR code.
        </p>
        <h5>Nome do destinatário: {collectorName}</h5>
        <p>Banco:{Banco}</p>
        <h5>Valor: R$ {transaction_amount}</h5>
    </div>
</div>
<img
    src={`data:image/png;base64,${qrCodeBase64}`}
    alt="QR Code"
    style="width: 100%; max-width: 300px; margin: 20px auto;"
/>
<div class="form-group">
    <label for="pixCode">Código PIX</label>
    <input
        type="text"
        id="pixCode"
        class="form-control"
        value={pixCode}
        readonly
    />
</div>
<button type="button" class="btn btn-primary" on:click={copyToClipboard}
    >Copiar Código PIX</button
>

<!-- Posicionamento do tooltip relativo ao botão -->
<div style="position: relative; display: inline-block;">
  <Tooltip message={tooltipmsg} visible={tooltipVisible} />
</div>


{#if horaExpiracao}
    <div style="margin-top: 10px;">
        Tempo restante: {formatTime(timeRemaining)}
    </div>
{/if}


<style>


  .hourglass-icon {
    color: #007bff; /* Cor azul do Bootstrap */
    font-size: 48px;
    animation: spin 2s infinite linear; /* Adicionando animação de rotação */
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .explicacoes {
    font-size: 14px; /* Define o tamanho das letras para pequeno */
  }
  .countdown {
    font-size: 2em;
    font-family: monospace;
  }

</style>